import React, { Component, PropType } from 'react'

class ErrorComponent extends React.Component {
    render() {
        let message = 'We could not load this component. Please reach out to your administrator for resolution.';
        if (this.props.message !== null && this.props.message !== undefined) {
            message = this.props.message;
        }
        return (
            <div id="errorDiv" className='d-flex flex-column align-items-center justify-content-center'>
                <div className="wd-70p wd-sm-250 wd-lg-300 align-self-center mg-y-15">
                    <img src="../images/img19.png" className="img-fluid" alt="" />
                </div>
                <div className="align-self-center">
                    <span className="tx-16 tx-medium">{message}</span>
                </div>
                <div>
                    <span className="tx-16 tx-medium"> Don't Worry! The support team has been notified of the same.</span>
                </div>
                <div>
                    <span className="tx-16 tx-medium"> Click <a href="/" id="errorPage">here</a> to go to Home Page</span>
                </div>
            </div>);
    }
}

export default ErrorComponent;